// extracted by mini-css-extract-plugin
export default {"divider":"_z-z"};